import { addMessages, init, locale } from "svelte-i18n";
import { LangEnums, storageModel } from "./lib/storage-manager";
import zhCN from "./assets/langs/zh-cn.json";
import zhHK from "./assets/langs/zh-hk.json";

type SupportedLocale = "zh-cn" | "zh-hk";

addMessages("zh-cn", zhCN);
addMessages("zh-hk", zhHK);

function normalizeLocale(raw?: string | null): SupportedLocale {
  const value = (raw || "").toLowerCase();
  if (["zh-cn", "zh_cn", "sc", "cn"].includes(value)) {
    return "zh-cn";
  }
  // 其余全部走繁体
  return "zh-hk";
}

function resolveStorageLocale(): SupportedLocale {
  if (storageModel.language === LangEnums.zhCN) {
    return "zh-cn";
  }
  // 繁体、英文、韩文、站外无值 → 统一繁体
  return "zh-hk";
}

function resolveLocale(): SupportedLocale {
  const urlLocale = new URLSearchParams(window.location.search).get("lang");
  return urlLocale ? normalizeLocale(urlLocale) : resolveStorageLocale();
}

export const currentLocale = resolveLocale();

init({
  fallbackLocale: "zh-hk",
  initialLocale: currentLocale,
});

locale.set(currentLocale);
